import { render } from "./BaseStar.vue?vue&type=template&id=0eb02f40&scoped=true"
import script from "./BaseStar.vue?vue&type=script&lang=js"
export * from "./BaseStar.vue?vue&type=script&lang=js"

import "./BaseStar.vue?vue&type=style&index=0&id=0eb02f40&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb02f40"]])

export default __exports__